(async function () {
  const root = document.querySelector('[data-price-root]');
  if (!root) return;

  const variantId = Number(root.getAttribute('data-variant-id'));
  if (!variantId) return;

  // Pull cart (automatic discounts are reflected here)
  const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!cartRes.ok) return;
  const cart = await cartRes.json();

  // Find a matching line item for this variant
  const line = cart.items.find((i) => i.variant_id === variantId);
  if (!line) return; // not in cart yet -> no way to know discounted final price

  // If discounted, rewrite the price container to show Code-1 style pricing
  if (line.original_price !== line.final_price) {
    const formatMoney = (cents) => {
      // Basic formatting; theme money formatting varies by theme
      try {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: cart.currency || 'USD',
        });
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };

    root.classList.add('price--on-sale');

    const container = root.querySelector('.price__container');
    if (!container) return;

    container.innerHTML = `
      <div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale">${formatMoney(line.final_price)}</span>
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular"><s>${formatMoney(line.original_price)}</s></span>
      </div>
    `;
  }
})();
